/**
 * Free shipping progress bar — Tinker/Horizon.
 * 1) Injecteert de bar (gerenderd via theme.liquid, verborgen in <body>)
 *    automatisch bovenin de cart drawer (.cart-drawer__content) en op de
 *    cart-pagina, ook wanneer het thema de drawer opnieuw rendert.
 * 2) Onderschept cart-mutaties (add/change/update/clear) en werkt de bar
 *    live bij op basis van /cart.js.
 */
(function () {
  var CART_ENDPOINTS = /\/cart\/(add|change|update|clear)(\.js)?/;
  var lastCart = null;

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var locale = document.documentElement.lang || 'nl';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
    }).format(cents / 100);
  }

  function updateBar(bar, cart) {
    var threshold = parseInt(bar.dataset.threshold, 10);
    if (!threshold || !cart) return;

    var total = cart.total_price;
    var remaining = threshold - total;
    var progress = Math.min((total / threshold) * 100, 100);

    var message = bar.querySelector('.fsb__message');
    var fill = bar.querySelector('.fsb__fill');
    fill.style.width = progress + '%';

    if (cart.item_count === 0) {
      message.innerHTML = 'Gratis verzending vanaf ' + formatMoney(threshold);
      fill.classList.remove('fsb__fill--complete');
    } else if (remaining > 0) {
      message.innerHTML =
        'Nog <strong>' + formatMoney(remaining) + '</strong> tot gratis verzending!';
      fill.classList.remove('fsb__fill--complete');
    } else {
      message.innerHTML = '✓ Gefeliciteerd, je hebt <strong>gratis verzending</strong>!';
      fill.classList.add('fsb__fill--complete');
    }
  }

  function updateAllBars(cart) {
    lastCart = cart;
    document.querySelectorAll('.fsb:not([data-fsb-source])').forEach(function (bar) {
      updateBar(bar, cart);
    });
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(updateAllBars)
      .catch(function () {});
  }

  // Plaatst een kopie van de bron-bar bovenin elke drawer/cart-container
  // die er nog geen heeft. Draait ook opnieuw na DOM-wijzigingen, omdat
  // Horizon de drawer-inhoud bij elke cart-update opnieuw rendert.
  function injectBars() {
    var source = document.querySelector('.fsb[data-fsb-source]');
    if (!source) return;

    var targets = document.querySelectorAll(
      '.cart-drawer__content, .cart-page__items, cart-items-component'
    );

    targets.forEach(function (target) {
      // Eén bar per drawer/pagina: sla over als er binnen dezelfde
      // container (dialog of main) al een zichtbare bar bestaat
      var container = target.closest('dialog') || target.closest('main') || document.body;
      if (container.querySelector('.fsb:not([data-fsb-source])')) return;

      var clone = source.cloneNode(true);
      clone.removeAttribute('data-fsb-source');
      target.prepend(clone);
      if (lastCart) updateBar(clone, lastCart);
    });
  }

  function init() {
    injectBars();
    new MutationObserver(function () {
      injectBars();
    }).observe(document.body, { childList: true, subtree: true });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Onderschep fetch-calls van het thema naar de Cart API
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var result = origFetch.apply(this, arguments);
    if (CART_ENDPOINTS.test(url)) {
      result.then(function () { setTimeout(refresh, 100); });
    }
    return result;
  };

  // Vangnet voor XMLHttpRequest
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_ENDPOINTS.test(url)) {
      this.addEventListener('load', function () { setTimeout(refresh, 100); });
    }
    return origOpen.apply(this, arguments);
  };
})();
